module.exports = __webpack_public_path__ + "9788f41e/img/ion_calendar-number.3ac5bd07.svg";